<template>
  <div id="driver" :class="['app-container', { 'game-overview-page': isBdc }]">
    <el-card shadow="always" class="card-box">
      <!-- 筛选工具 -->
      <div class="filter-container bdc-filter-bar">
        <div class="bdc-filter-left">
          <el-input v-model="tiaojian.gameName" class="filter-item bdc-filter-search" prefix-icon="el-icon-search" clearable placeholder="游戏名模糊查询" />

          <multiple-select key="运营方" v-model="tiaojian.operators" class="filter-item bdc-filter-operator" collapse-tags filterable clearable placeholder="运营方" :props="{label:'label', value:'value'}" :options-list="operatorsList" />

          <multiple-select key="发行地区" v-model="tiaojian.distributionRegion" class="filter-item" collapse-tags filterable clearable placeholder="发行地区" :props="{label:'label', value:'value'}" :options-list="distributionRegion" />

          <multiple-select v-show="radio1=='2'" key="平台" v-model="tiaojian.platforms" class="filter-item" collapse-tags filterable clearable placeholder="平台" :props="{label:'label', value:'value'}" :options-list="platforms_list" />

          <el-button type="primary" class="bdc-filter-query" @click="chaxun_btn">查询</el-button>
        </div>
        <div class="bdc-filter-right">
          <el-radio-group v-model="radio1" class="bdc-dimension-tabs">
            <el-radio-button label="1">日维度</el-radio-button>
            <el-radio-button label="2">月度KPI</el-radio-button>
          </el-radio-group>

          <el-popover width="500" trigger="hover" popper-class="bdc-metric-tip-popper">
            <span v-if="radio1=='1'" class="zhibiaoshuoming1" style="color:#333333;font-size:12px">

              <span>* 昨日新增人数：</span>昨日的新增数
              <br>
              <span>* 昨日收入金额：</span>昨日的收入金额，币种统一为“人民币”
              <br>
              <span>* 昨日DAU：</span>昨日的去重活跃数
              <br>
              <span>* 昨日次留率：</span>前日的次留人数/前日的新增人数
              <br>
              <span>* 昨日活跃ARPU：</span>昨日收入金额 / 昨日DAU
              <br>
              <span>* 昨日LTV1：</span>昨日新增收入金额 / 昨日新增人数
              <br>
              <br>
              <span>* 今日新增人数：</span>今日的新增人数，每小时更新一次
              <br>
              <span>* 今日收入金额：</span>今日的收入金额，每小时更新一次
              <br>
              <span>* 今日DAU：</span>今日的去重活跃人数，每小时更新一次
              <br>
              <span>* 今日次留率：</span>截止到今日上个小时的留存人数 / 昨天新增人数，每小时更新一次
              <br>
              <span>* 活跃ARPU：</span>今日的收入金额 / 今日DAU，每小时更新一次
              <br>
              <br>
              <span>昨日的对比数据：</span>表示环比前一天的数据情况
              <br>
              <span>今日的对比数据：</span>表示环比昨日截止到同小时的数据情况

            </span>
            <span v-if="radio1=='2'" class="zhibiaoshuoming1" style="color:#333333;font-size:12px">
              <span>* 月流水金额：</span>自然月内，截止到昨日的累计收入金额，币种统一为“人民币”。
              <br>
              <span>* 月新增人数：</span>自然月内，截止到昨日的累计新增人数
              <br>
              <span>* 月度目标：</span>自然月内，管理员设置的当月目标值
              <br>
              <span>*剩余天数：</span>表示距离本月结束还有多少天，包含今天
              <br>
              <span>*剩余日均流水：</span>表示在本月剩余天数每天需要完成多少流水才可以完成本月KPI
              <br>
              <span>*剩余日均新增：</span>表示在本月剩余天数每天需要完成多少新增才可以完成本月KPI
            </span>
            <bdc-help-icon slot="reference" :size="15" class="bdc-metric-help-trigger" />
          </el-popover>

        </div>

      </div>
      <div class="filter-container bdc-filter-bar">
        <span v-if="radio1=='1'" class="bdc-update-time">{{ updateTime }}</span>
        <span v-if="radio1=='2'" class="bdc-update-time">{{ updateTime1 }}</span>
      </div>
      <!-- &&isAdmin_Vip -->
      <!-- 提前加载图片确保切换到月维度不会卡顿 -->
      <img :src="zongjibg1" style="width:0px;height:0px" />
      <!-- BDC 月度 KPI 汇总 -->
      <div v-if="isBdc" v-show="radio1=='2'" class="bdc-kpi-summary-v2">
        <div class="bdc-kpi-summary-v2__aside">
          <div class="bdc-kpi-summary-v2__title">
            数据汇总
            <el-tooltip effect="dark" content="全部游戏" placement="top">
              <bdc-help-icon :size="15" class="bdc-kpi-summary-v2__help" />
            </el-tooltip>
          </div>
          <div class="bdc-kpi-summary-v2__subtitle">（截至昨日）</div>
        </div>
        <div class="bdc-kpi-summary-v2__metric">
          <div class="bdc-kpi-summary-v2__metric-main">
            <div class="bdc-kpi-summary-v2__metric-head">
              <span class="bdc-kpi-summary-v2__metric-icon">
                <img :src="bdcKpiIncomeIcon" alt="" class="bdc-kpi-summary-v2__metric-icon-img">
              </span>
              <span>月流水金额（¥）</span>
            </div>
            <div class="bdc-kpi-summary-v2__metric-value">
              <span class="bdc-kpi-summary-v2__metric-currency">¥</span><count-to :start-val="0" :end-val="incomeSum" :duration="2000" :decimals="2" />
            </div>
            <div class="bdc-kpi-summary-v2__metric-target">
              <img :src="bdcKpiTargetIcon" alt="" class="bdc-kpi-summary-v2__target-icon-img">
              <span>月度目标：¥<count-to :start-val="0" :end-val="incomeKpiSums" :duration="2000" :decimals="2" /></span>
            </div>
          </div>
          <div class="bdc-kpi-summary-v2__progress-wrap" :class="kpiProgressWrapClass(incomeKpirate)">
            <el-progress type="circle" :width="88" :stroke-width="8" color="#11B485" :percentage="incomeKpirate" :format="kpiProgressFormat" />
            <span class="bdc-kpi-summary-v2__progress-caption">完成率</span>
          </div>
        </div>
        <div class="bdc-kpi-summary-v2__metric">
          <div class="bdc-kpi-summary-v2__metric-main">
            <div class="bdc-kpi-summary-v2__metric-head">
              <span class="bdc-kpi-summary-v2__metric-icon">
                <img :src="bdcKpiUsersIcon" alt="" class="bdc-kpi-summary-v2__metric-icon-img">
              </span>
              <span>月新增人数</span>
            </div>
            <div class="bdc-kpi-summary-v2__metric-value">
              <count-to :start-val="0" :end-val="regroleSum" :duration="1000" :decimals="0" />
            </div>
            <div class="bdc-kpi-summary-v2__metric-target">
              <img :src="bdcKpiTargetIcon" alt="" class="bdc-kpi-summary-v2__target-icon-img">
              <span>月度目标：<count-to :start-val="0" :end-val="regroleKpiSums" :duration="1000" :decimals="0" /></span>
            </div>
          </div>
          <div class="bdc-kpi-summary-v2__progress-wrap" :class="kpiProgressWrapClass(regroleKpirate)">
            <el-progress type="circle" :width="88" :stroke-width="8" color="#11B485" :percentage="regroleKpirate" :format="kpiProgressFormat" />
            <span class="bdc-kpi-summary-v2__progress-caption">完成率</span>
          </div>
        </div>
      </div>
      <!-- 非 BDC 月度 KPI 汇总 -->
      <div v-else v-show="radio1=='2'" class="zongjiDiv" :style="zongjibg">
        <div class="zongjiDiv_list" style="width:18%;text-align: center;">
          <div class="zongjiDiv_list_title" style="font-size: 16px;margin-top:38px">数据汇总
            <el-tooltip class="item" effect="dark" content="全部游戏" placement="top">
              <svg-icon icon-class="bangzhu" class="icon" style="margin-left:4px" />
            </el-tooltip>
          </div>
          <div class="zongjiDiv_list_value" style="font-size: 12px;font-weight: 100;">(截至昨日)</div>
        </div>
        <div class="zongjiDiv_list" style="margin-left: 6%;">
          <div class="zongjiDiv_list_title">月流水金额（¥）</div>
          <div class="zongjiDiv_list_value">¥
            <count-to :start-val="0" :end-val="incomeSum" :duration="2000" :decimals="2" />
          </div>
          <div class="zongjiDiv_list_yue">月度目标：¥
            <count-to :start-val="0" :end-val="incomeKpiSums" :duration="2000" :decimals="2" />
          </div>
        </div>
        <div style="float:left;margin-top:20px" class="huizongjindu">
          <el-progress :width="80" type="circle" color="#FFCE42" :stroke-width="7" :percentage="incomeKpirate" />
        </div>
        <div class="bdc-kpi-divider" style="border-left:1px solid #fff;height:70px;float:left;margin:25px 5%;opacity: 0.2;" />
        <div class="zongjiDiv_list" style="width:15%">
          <div class="zongjiDiv_list_title">月新增人数</div>
          <div class="zongjiDiv_list_value">
            <count-to :start-val="0" :end-val="regroleSum" :duration="1000" :decimals="0" />
          </div>
          <div class="zongjiDiv_list_yue">月度目标：
            <count-to :start-val="0" :end-val="regroleKpiSums" :duration="1000" :decimals="0" />
          </div>
        </div>
        <div style="float:left;margin-top:20px" class="huizongjindu">
          <el-progress :width="80" type="circle" color="#FFCE42" :stroke-width="7" :percentage="regroleKpirate" />
        </div>
      </div>
      <!-- 表格 v-show="radio1=='1'" -->
      <!-- element-loading-spinner="el-icon-loading" -->
      <!-- element-loading-text="拼命加载中" -->

      <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
        <el-table v-show="radio1=='1'" ref="table1" v-loading="listLoading" class="grayTableTile_02" :data="caseTable" style="width: 100%;" :height="tableHeightDaily" :default-sort="{prop: 'incomeYesterday', order: 'descending'}" @sort-change="handleAgeSortChange">
          <el-table-column width="160px" label="游戏名称" align="center" fixed>
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="jinruyouxi(scope.row)">
                <img style="width:56px;height:56px; border-radius: 10px;" :src="scope.row.gamePicture">

                <div style="height: 16px;line-height: 16px;text-align:center;">
                  <el-tooltip class="item" :effect="isBdc ? 'light' : 'dark'" :content="scope.row.gameName" :placement="isBdc ? 'bottom' : 'top-start'" :popper-class="isBdc ? 'bdc-game-name-tooltip' : ''">
                    <span style="font-size:12px;font-weight:bold">{{ scope.row.gameName | namefilters }}</span>
                  </el-tooltip>
                </div>
              </span>
            </template>
          </el-table-column>

          <el-table-column key="column1" :min-width="isBdc ? '96px' : '75px'" :width="isBdc ? '96px' : undefined" label="" align="center" fixed>
            <template slot-scope="scope">
              <div :class="isBdc ? 'bdc-day-tag' : 'tric2'">昨日{{ scope.row.theDimension | theDimensions }}</div>
              <div :class="isBdc ? ['bdc-day-tag', 'bdc-day-tag--today'] : 'tric3'" style="margin-top:20px">今日{{ scope.row.theDimension | theDimensions }}</div>
            </template>
          </el-table-column>

          <el-table-column key="column2" min-width="180px" label="新增人数" sortable="custom" property="regroleYesterday">
            <template slot-scope="scope">

              <div style="float:left;width:80px;">
                <div class="textlin" style="margin-top:4px">
                  <count-to class="textlin" style="font-weight: bold;" :start-val="0" :end-val="parseFloat(scope.row.regroleYesterday)" :duration="1" :decimals="0" />
                </div>
                <div class="textlin" style="margin-top:25px">
                  <count-to class="textlin" style="font-weight: bold;" :start-val="0" :end-val="parseFloat(scope.row.regroleToday)" :duration="1" :decimals="0" />
                </div>
              </div>
              <div style="float:left;">
                <div style="float:left;width:100%">
                  <span v-if="scope.row.regroleCompareYesterday == '--'" style="color:#999999">--</span>
                  <span v-else-if="scope.row.regroleCompareYesterday=='0'" style="color:#999999">0%</span>
                  <span v-else-if="scope.row.regroleCompareYesterday.length>8" style="color:#999999">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.regroleCompareYesterday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.regroleCompareYesterday, 'yesterday')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:4px;" :icon-class="scope.row.regroleCompareYesterday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:0px;" :class="trendTextClass(scope.row.regroleCompareYesterday)">{{ scope.row.regroleCompareYesterday }}%
                    </span>
                  </span>
                </div>
                <div style="width:100%">
                  <span v-if="scope.row.regroleCompareToday == '--'" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else-if="scope.row.regroleCompareToday=='0'" style="color:#999999;float:left;margin-top:16px;">0%</span>
                  <span v-else-if="scope.row.regroleCompareToday.length>8" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.regroleCompareToday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.regroleCompareToday, 'today')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:20px;" :icon-class="scope.row.regroleCompareToday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:16px;" :class="trendTextClass(scope.row.regroleCompareToday)">{{ scope.row.regroleCompareToday }}%
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="column3" min-width="210px" label="收入金额（¥）" sortable="custom" property="incomeYesterday">
            <template slot-scope="scope">

              <div style="float:left;width:110px;">
                <div class="bdc-amount-line" style="margin-top:4px">
                  <span style="font-weight: bold;">¥ </span>
                  <count-to class="textlin" style="font-weight: bold;" :start-val="0" :end-val="parseFloat(scope.row.incomeYesterday)" :duration="1" :decimals="2" />
                </div>
                <div class="bdc-amount-line" style="margin-top:25px">
                  <span style="font-weight: bold;">¥ </span>
                  <count-to class="textlin" style="font-weight: bold;" :start-val="0" :end-val="parseFloat(scope.row.incomeToday)" :duration="1" :decimals="2" />
                </div>
              </div>
              <div style="float:left;">
                <div style="float:left;width:100%">
                  <span v-if="scope.row.incomeCompareYesterday == '--'" style="color:#999999">--</span>
                  <span v-else-if="scope.row.incomeCompareYesterday=='0'" style="color:#999999">0%</span>
                  <span v-else-if="scope.row.incomeCompareYesterday.length>8" style="color:#999999">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.incomeCompareYesterday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.incomeCompareYesterday, 'yesterday')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:4px;" :icon-class="scope.row.incomeCompareYesterday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:0px;" :class="trendTextClass(scope.row.incomeCompareYesterday)">{{ scope.row.incomeCompareYesterday }}%
                    </span>
                  </span>
                </div>
                <div style="width:100%">
                  <span v-if="scope.row.incomeCompareToday == '--'" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else-if="scope.row.incomeCompareToday=='0'" style="color:#999999;float:left;margin-top:16px;">0%</span>
                  <span v-else-if="scope.row.incomeCompareToday.length>8" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.incomeCompareToday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.incomeCompareToday, 'today')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:20px;" :icon-class="scope.row.incomeCompareToday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:16px;" :class="trendTextClass(scope.row.incomeCompareToday)">{{ scope.row.incomeCompareToday }}%
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="column4" min-width="200px" label="DAU" sortable="custom" property="dauYesterday">
            <template slot-scope="scope">
              <div style="float:left;width:100px;">
                <div class="textlin" style="margin-top:4px">
                  <count-to class="textlin" style="font-weight: bold;" :start-val="0" :end-val="parseFloat(scope.row.dauYesterday)" :duration="1" :decimals="0" />
                </div>
                <div class="textlin" style="margin-top:25px">
                  <count-to class="textlin" style="font-weight: bold;" :start-val="0" :end-val="parseFloat(scope.row.dauToday)" :duration="1" :decimals="0" />
                </div>
              </div>
              <div style="float:left;">
                <div style="float:left;width:100%">
                  <span v-if="scope.row.dauCompareYesterday == '--'" style="color:#999999">--</span>
                  <span v-else-if="scope.row.dauCompareYesterday=='0'" style="color:#999999">0%</span>
                  <span v-else-if="scope.row.dauCompareYesterday.length>8" style="color:#999999">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.dauCompareYesterday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.dauCompareYesterday, 'yesterday')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:4px;" :icon-class="scope.row.dauCompareYesterday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:0px;" :class="trendTextClass(scope.row.dauCompareYesterday)">{{ scope.row.dauCompareYesterday }}%
                    </span>
                  </span>
                </div>
                <div style="width:100%">
                  <span v-if="scope.row.dauCompareToday == '--'" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else-if="scope.row.dauCompareToday=='0'" style="color:#999999;float:left;margin-top:16px;">0%</span>
                  <span v-else-if="scope.row.dauCompareToday.length>8" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.dauCompareToday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.dauCompareToday, 'today')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:20px;" :icon-class="scope.row.dauCompareToday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:16px;" :class="trendTextClass(scope.row.dauCompareToday)">{{ scope.row.dauCompareToday }}%
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="column5" min-width="160px" label="次留率">
            <template slot-scope="scope">

              <div style="float:left;width:50px;">
                <div class="textlin" style="margin-top:4px">{{ scope.row.retainYesterday }}</div>
                <div class="textlin" style="margin-top:25px">{{ scope.row.retainToday }}</div>
              </div>
              <div style="float:left;">
                <div style="float:left;width:100%">
                  <span v-if="scope.row.retainCompareYesterday == '--'" style="color:#999999">--</span>
                  <span v-else-if="scope.row.retainCompareYesterday=='0'" style="color:#999999">0%</span>
                  <span v-else-if="scope.row.retainCompareYesterday.length>8" style="color:#999999">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.retainCompareYesterday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.retainCompareYesterday, 'yesterday')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:4px;" :icon-class="scope.row.retainCompareYesterday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:0px;" :class="trendTextClass(scope.row.retainCompareYesterday)">{{ scope.row.retainCompareYesterday }}%
                    </span>
                  </span>
                </div>
                <div style="width:100%">
                  <span v-if="scope.row.retainCompareToday == '--'" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else-if="scope.row.retainCompareToday=='0'" style="color:#999999;float:left;margin-top:16px;">0%</span>
                  <span v-else-if="scope.row.retainCompareToday.length>8" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.retainCompareToday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.retainCompareToday, 'today')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:20px;" :icon-class="scope.row.retainCompareToday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:16px;" :class="trendTextClass(scope.row.retainCompareToday)">{{ scope.row.retainCompareToday }}%
                    </span>
                  </span>
                </div>
              </div>

            </template>
          </el-table-column>

          <el-table-column key="column6" min-width="160px" label="活跃ARPU">
            <template slot-scope="scope">

              <div style="float:left;width:50px;">
                <div class="textlin" style="margin-top:4px">{{ scope.row.arpuYesterday }}</div>
                <div class="textlin" style="margin-top:25px">{{ scope.row.arpuToday }}</div>
              </div>
              <div style="float:left;">
                <div style="float:left;width:100%">
                  <span v-if="scope.row.arpuCompareYesterday == '--'" style="color:#999999">--</span>
                  <span v-else-if="scope.row.arpuCompareYesterday=='0'" style="color:#999999">0%</span>
                  <span v-else-if="scope.row.arpuCompareYesterday.length>8" style="color:#999999">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.arpuCompareYesterday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.arpuCompareYesterday, 'yesterday')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:4px;" :icon-class="scope.row.arpuCompareYesterday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:0px;" :class="trendTextClass(scope.row.arpuCompareYesterday)">{{ scope.row.arpuCompareYesterday }}%
                    </span>
                  </span>
                </div>
                <div style="width:100%">
                  <span v-if="scope.row.arpuCompareToday == '--'" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else-if="scope.row.arpuCompareToday=='0'" style="color:#999999;float:left;margin-top:16px;">0%</span>
                  <span v-else-if="scope.row.arpuCompareToday.length>8" style="color:#999999;float:left;margin-top:16px;">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.arpuCompareToday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.arpuCompareToday, 'today')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:20px;" :icon-class="scope.row.arpuCompareToday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:16px;" :class="trendTextClass(scope.row.arpuCompareToday)">{{ scope.row.arpuCompareToday }}%
                    </span>
                  </span>
                </div>
              </div>

            </template>
          </el-table-column>

          <el-table-column key="column7" min-width="160px" label="LTV1">
            <template slot-scope="scope">

              <div style="float:left;width:50px;">
                <div class="textlin" style="margin-top:4px">{{ scope.row.ltvYesterday }}</div>
                <div class="textlin" style="margin-top:25px">-</div>
              </div>
              <div style="float:left;">
                <div style="float:left;width:100%">
                  <span v-if="scope.row.ltvCompareYesterday == '--'" style="color:#999999">--</span>
                  <span v-else-if="scope.row.ltvCompareYesterday=='0'" style="color:#999999">0%</span>
                  <span v-else-if="scope.row.ltvCompareYesterday.length>8" style="color:#999999">--</span>
                  <span v-else>
                    <img v-if="isBdc" :src="trendIconSrc(scope.row.ltvCompareYesterday)" class="bdc-trend-icon" :style="trendIconStyle(scope.row.ltvCompareYesterday, 'yesterday')" alt="" /><svg-icon v-else style="transform:rotate(180deg);float:left;margin-top:4px;" :icon-class="scope.row.ltvCompareYesterday>0?'lvjian':'hongjian'" class="icon" /><span style="float:left;margin-top:0px;" :class="trendTextClass(scope.row.ltvCompareYesterday)">{{ scope.row.ltvCompareYesterday }}%
                    </span>
                  </span>
                </div>
                <div style="width:100%" />
              </div>

            </template>
          </el-table-column>

        </el-table>

        <!-- BDC 月度 KPI 表格 -->
        <el-table v-show="radio1=='2' && isBdc" ref="table2" v-loading="listLoading2" class="grayTableTile_02 bdc-monthly-table" element-loading-text="拼命加载中" :data="caseTable2" style="width: 100%;" :height="tableHeightMonthly">
          <el-table-column min-width="160px" label="游戏名称" align="center" fixed>
            <template slot-scope="scope">
              <div class="bdc-game-cell" @click="jinruyouxi(scope.row)">
                <img class="bdc-game-cell__icon" :src="scope.row.gamePicture" alt="">
                <el-tooltip effect="light" :content="scope.row.gameName" placement="bottom" popper-class="bdc-game-name-tooltip">
                  <span class="bdc-game-cell__name">{{ scope.row.gameName | namefilters }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="月流水金额（¥）" align="left">
            <el-table-column min-width="160px" label="" class-name="bdc-kpi-sub-col bdc-kpi-sub-col--done">
              <template slot-scope="scope">
                <div class="bdc-kpi-cell">
                  <div class="bdc-kpi-cell__label">
                    <span>截止昨日完成</span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content">计算维度：{{ scope.row.theDimension | theDimensions }}</div>
                      <bdc-help-icon :size="12" class="bdc-kpi-cell__info" />
                    </el-tooltip>
                  </div>
                  <div class="bdc-kpi-cell__value bdc-kpi-cell__value--accent">
                    ¥<count-to :start-val="0" :end-val="parseFloat(scope.row.incomeYesterday)" :duration="1" :decimals="2" />
                  </div>
                  <div class="bdc-kpi-cell__meta">剩余天数：{{ scope.row.last_days }}天</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="220px" label="" class-name="bdc-kpi-sub-col bdc-kpi-sub-col--target">
              <template slot-scope="scope">
                <div class="bdc-kpi-cell">
                  <div class="bdc-kpi-cell__label">月度目标</div>
                  <div class="bdc-kpi-cell__value">
                    ¥<count-to :start-val="0" :end-val="parseFloat(scope.row.incomeTargetYesterday)" :duration="1" :decimals="2" />
                  </div>
                  <div class="bdc-kpi-cell__meta">
                    剩余日均流水：¥<count-to :start-val="0" :end-val="parseFloat(scope.row.shourujunzhi)" :duration="1" :decimals="2" />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="108px" label="" align="left" class-name="bdc-kpi-sub-col bdc-kpi-sub-col--progress">
              <template slot-scope="scope">
                <el-progress :width="50" style="margin-right: 50px;" type="circle" color="#11B485" :stroke-width="4" :percentage="scope.row.circle" />
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="月新增人数" align="left">
            <el-table-column min-width="140px" label="" class-name="bdc-kpi-sub-col bdc-kpi-sub-col--done">
              <template slot-scope="scope">
                <div class="bdc-kpi-cell">
                  <div class="bdc-kpi-cell__label">
                    <span>截止昨日完成</span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content">计算维度：{{ scope.row.theDimension | theDimensions }}</div>
                      <bdc-help-icon :size="12" class="bdc-kpi-cell__info" />
                    </el-tooltip>
                  </div>
                  <div class="bdc-kpi-cell__value bdc-kpi-cell__value--accent">
                    <count-to :start-val="0" :end-val="parseFloat(scope.row.regroleYesterday)" :duration="1" :decimals="0" />
                  </div>
                  <div class="bdc-kpi-cell__meta">剩余天数：{{ scope.row.last_days }}天</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="200px" label="" class-name="bdc-kpi-sub-col bdc-kpi-sub-col--target">
              <template slot-scope="scope">
                <div class="bdc-kpi-cell">
                  <div class="bdc-kpi-cell__label">月度目标</div>
                  <div class="bdc-kpi-cell__value">
                    <count-to :start-val="0" :end-val="parseFloat(scope.row.regroleTargetYesterday)" :duration="1" :decimals="0" />
                  </div>
                  <div class="bdc-kpi-cell__meta">
                    剩余日均新增：<count-to :start-val="0" :end-val="parseFloat(scope.row.xinzengjunzhi)" :duration="1" :decimals="0" />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="108px" label="" align="left" class-name="bdc-kpi-sub-col bdc-kpi-sub-col--progress">
              <template slot-scope="scope">
                <el-progress :width="50" style="margin-right: 50px;" type="circle" color="#11B485" :stroke-width="4" :percentage="scope.row.circle2" />
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column key="column11-bdc" min-width="160px" label="操作" align="center">
            <template slot-scope="scope">
              <div class="bdc-monthly-actions">
                <el-button type="text" class="bdc-monthly-actions__muted" :disabled="!isVip_2" :title="!isVip_2?'权限不足':false" @click="bianjimubiao(scope.$index, scope.row)">
                  编辑目标
                </el-button>
                <span class="bdc-monthly-actions__sep">|</span>
                <el-button type="text" class="bdc-monthly-actions__link" @click="chakanlishi(scope.row)">
                  查看历史
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 非 BDC 月度 KPI 表格 -->
        <el-table v-show="radio1=='2' && !isBdc" ref="table2" v-loading="listLoading2" class="grayTableTile_02" element-loading-text="拼命加载中" :data="caseTable2" style="width: 100%;" :height="tableHeightMonthly">
          <el-table-column width="160px" label="游戏名称" align="center">
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="jinruyouxi(scope.row)">
                <img style="width:56px;height:56px; border-radius: 10px;" :src="scope.row.gamePicture">
                <div style="height: 16px;line-height: 16px;text-align:center;">
                  <el-tooltip class="item" effect="dark" :content="scope.row.gameName" placement="top-start">
                    <span style="font-size:12px;font-weight:bold">{{ scope.row.gameName | namefilters }}</span>
                  </el-tooltip>
                </div>
              </span>
            </template>
          </el-table-column>

          <!-- <el-table-column min-width="50px" label="" align="center" key="column8">
          <template slot-scope="scope">
            <div class="tric3">截止昨日</div>
            <div style="margin-top:20px" class="tric2">月度目标</div>
          </template>
        </el-table-column> -->

          <el-table-column key="column9" min-width="460px" label="月流水金额（¥）">
            <template slot-scope="scope">

              <div style="display: inline-block;height: 72px;">

                <div style="float:left;margin-right:30px;min-width:130px">
                  <div style="color: #999;font-size:12px">
                    <span>截止昨日完成</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">计算维度：{{ scope.row.theDimension | theDimensions }}</div>
                      <svg-icon icon-class="bangzhu" class="icon" style="margin-left:4px" />
                    </el-tooltip>
                  </div>
                  <div style="font-size:16px;margin-top: 7px;">
                    <span style="font-weight: bold;color: #3A89FF;font-size:14px">¥ </span>
                    <count-to class="textlin" style="color: #3A89FF;" :start-val="0" :end-val="parseFloat(scope.row.incomeYesterday)" :duration="1" :decimals="2" />
                  </div>
                  <div style="color: #666666;font-size:12px;margin-top: 8px;"><span>剩余天数：</span><span>{{ scope.row.last_days }}天</span></div>
                </div>

                <div style="float:left;min-width:180px">
                  <div style="color: #999;font-size:12px">
                    <span>月度目标</span>
                  </div>
                  <div style="font-size:16px;margin-top: 7px;">
                    <span style="font-weight: bold;color: #333333;font-size:14px">¥ </span>
                    <count-to class="textlin" style="color: #333333;" :start-val="0" :end-val="parseFloat(scope.row.incomeTargetYesterday)" :duration="1" :decimals="2" />
                  </div>
                  <div style="color: #666666;font-size:12px;margin-top: 8px;">
                    <span>剩余日均流水：¥ </span>
                    <count-to style="color: #666666" :start-val="0" :end-val="parseFloat(scope.row.shourujunzhi)" :duration="1" :decimals="2" />
                  </div>
                </div>

                <div style="float:left;width:20px;height:100px;" />
                <div style="float:left;margin-top: 5px;">
                  <el-progress :width="66" type="circle" color="#3A89FF" :stroke-width="5" :percentage="scope.row.circle" />
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="column10" min-width="420px" label="月新增人数">
            <template slot-scope="scope">
              <div style="display: inline-block;height: 72px;">

                <div style="float:left;margin-right:30px;min-width:120px">
                  <div style="color: #999;font-size:12px">
                    <span>截止昨日完成</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">计算维度：{{ scope.row.theDimension | theDimensions }}</div>
                      <svg-icon icon-class="bangzhu" class="icon" style="margin-left:4px" />
                    </el-tooltip>
                  </div>
                  <div style="font-size:16px;margin-top: 7px;">
                    <count-to class="textlin" style="color: #3A89FF;" :start-val="0" :end-val="parseFloat(scope.row.regroleYesterday)" :duration="1" :decimals="0" />
                  </div>
                  <div style="color: #666666;font-size:12px;margin-top: 8px;"><span>剩余天数：</span><span>{{ scope.row.last_days }}天</span></div>
                </div>

                <div style="float:left;min-width:140px">
                  <div style="color: #999;font-size:12px">
                    <span>月度目标</span>
                  </div>
                  <div style="font-size:16px;margin-top: 7px;">
                    <count-to class="textlin" style="color: #333333;" :start-val="0" :end-val="parseFloat(scope.row.regroleTargetYesterday)" :duration="1" :decimals="0" />
                  </div>
                  <div style="color: #666666;font-size:12px;margin-top: 8px;">
                    <span>剩余日均新增：</span>
                    <count-to style="color: #666666" :start-val="0" :end-val="parseFloat(scope.row.xinzengjunzhi)" :duration="1" :decimals="0" />
                  </div>
                </div>

                <div style="float:left;width:20px;height:100px;" />
                <div style="float:left;margin-top: 5px;">
                  <el-progress :width="66" type="circle" color="#3A89FF" :stroke-width="5" :percentage="scope.row.circle2" />
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column key="column11" width="180px" label="操作" align="center">
            <template slot-scope="scope">
              <el-button style="padding: 5px" type="text" :disabled="!isVip_2" :title="!isVip_2?'权限不足':false" @click="bianjimubiao(scope.$index, scope.row)">
                编辑目标
              </el-button>
              <span style="border-left:1px solid #CCCCCC;height:12px;" />
              <el-button style="padding: 5px" type="text" @click="chakanlishi(scope.row)">
                查看历史
              </el-button>

            </template>
          </el-table-column>

        </el-table>
      </div>

    </el-card>
    <el-dialog title="编辑目标" :visible.sync="dialogFormVisible" width="700px" :close-on-click-modal="false">

      <div style="float:left;margin-bottom:30px">
        <div style="float:left">
          目标月:<span style="margin-left:10px">{{ form.monthTime }}月</span>
          <el-popover placement="top-start" width="260" trigger="hover">
            <span class="zhibiaoshuoming1" style="color:#666666">
              系统自动调取当前月
            </span>
            <svg-icon slot="reference" icon-class="bangzhu" class="icon" style="color:#666666;margin-left:20px" />
          </el-popover>
        </div>
        <div style="margin-top:30px;float:left">
          <div style="float:left;font-weight: 600;">流水目标设置（¥）</div>
          <div style="float:right">总目标：
            <count-to style="color: #666666" :start-val="0" :end-val="parseFloat(form.payKpiIos)+parseFloat(form.payKpiAndroid)+parseFloat(form.payKpiOther)" :duration="1" :decimals="2" />
          </div>
          <div style="float:left;margin-top:10px;background: #F7F7F7;padding:13px;width:100%">
            <span style="margin-left:40px;">IOS</span>
            <el-input v-model="form.payKpiIos" type="number" style="width:140px" />
            <span style="margin-left:30px;">安卓</span>
            <el-input v-model="form.payKpiAndroid" type="number" style="width:140px" />
            <span style="margin-left:30px;">其他</span>
            <el-input v-model="form.payKpiOther" type="number" style="width:140px" />
          </div>
        </div>
        <div style="margin-top:30px;float:left">
          <div style="float:left;font-weight: 600;">新增目标设置</div>
          <div style="float:right">总目标：
            <count-to style="color: #666666" :start-val="0" :end-val="parseFloat(form.regKpiIos)+parseFloat(form.regKpiAndroid)+parseFloat(form.regKpiOther)" :duration="1" :decimals="0" />
          </div>
          <div style="float:right;margin-right:40px">计算维度：{{ info_theDimension | theDimensions }}</div>
          <div style="float:left;margin-top:10px;background: #F7F7F7;padding:13px;width:100%">
            <span style="margin-left:40px;">IOS</span>
            <el-input v-model="form.regKpiIos" type="number" style="width:140px" />
            <span style="margin-left:30px;">安卓</span>
            <el-input v-model="form.regKpiAndroid" type="number" style="width:140px" />
            <span style="margin-left:30px;">其他</span>
            <el-input v-model="form.regKpiOther" type="number" style="width:140px" />
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="SaveKpi()">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="tableTitle" :visible.sync="dialogTableVisible" width="80%" top="8vh" :close-on-click-modal="false">
      <el-table :data="tableData1" class="grayTableTile_02" height="500px" row-key="monthTime" :tree-props="{children: 'historyMonthListVo'}">
        <el-table-column prop="monthTime" label="自然月" min-width="180px" />
        <el-table-column prop="pay" label="流水金额（¥）" min-width="140px">
          <template slot-scope="scope">
            <count-to :start-val="0" :end-val="parseFloat(scope.row.pay==null?0.00:scope.row.pay)" :duration="1" :decimals="2" />
          </template>
        </el-table-column>
        <el-table-column prop="payKpi" label="流水目标" min-width="180px">
          <template slot-scope="scope">
            <count-to :start-val="0" :end-val="parseFloat(scope.row.payKpi==null?0.00:scope.row.payKpi)" :duration="1" :decimals="2" />
          </template>
        </el-table-column>
        <el-table-column prop="payKpiPercentage" label="流水完成度" min-width="100px" />
        <el-table-column prop="reg" label="新增人数" min-width="140px">
          <template slot-scope="scope">
            <count-to :start-val="0" :end-val="parseFloat(scope.row.reg==null?0.00:scope.row.reg)" :duration="1" :decimals="2" />
          </template>
        </el-table-column>
        <el-table-column prop="regKpi" label="新增目标" min-width="180px">
          <template slot-scope="scope">
            <count-to :start-val="0" :end-val="parseFloat(scope.row.regKpi==null?0.00:scope.row.regKpi)" :duration="1" :decimals="2" />
          </template>
        </el-table-column>
        <el-table-column prop="regKpiPercentage" label="新增完成度" min-width="100px" />
        <el-table-column label="操作" min-width="60px">
          <template slot-scope="scope">
            <el-button v-if="scope.row.historyMonthListVo" style="padding: 5px" type="text" :disabled="!isVip_2" :title="!isVip_2?'权限不足':false" @click="bianjimubiao1(scope.$index, scope.row)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { gateUrlSasapiGet, homepageOperatorsList, homepageDistributionRegion, homepageSaveKpi } from '@Sys~/api/sys'
import ChartPage from '@Bdc~/views/gameData/components/chartPage'
import Store from '@Sys~/store'
import MultipleSelect from '@Sys~/components/MultipleSelect'
import CountTo from 'vue-count-to'
const name = Store.getters.currentRoute.name
export default {
  name: name,
  components: { ChartPage, MultipleSelect, CountTo },

  filters: {
    // 合作方式
    namefilters(value) {
      if (value == null) {
        return value
      } else if (value.length > 8) {
        var val = value.substring(0, 8) + '...'
        return val
      } else {
        return value
      }
    },
    theDimensions(value) {
      var list = {
        1: '角色',
        2: '账号',
        3: '设备'
      }
      return list[value]
    }
  },
  data() {
    return {
      isBdc: process.env.VUE_APP_PROJECT_TYPE === 'bdc',
      bdcKpiIncomeIcon: require('@Sys~/assets/bdc-kpi/bdc-kpi-income.svg'),
      bdcKpiUsersIcon: require('@Sys~/assets/bdc-kpi/bdc-kpi-users.svg'),
      bdcKpiTargetIcon: require('@Sys~/assets/bdc-kpi/bdc-kpi-target.svg'),
      bdcTrendUpIcon: require('@Sys~/assets/bdc-kpi/bdc-trend-up.svg'),
      bdcTrendDownIcon: require('@Sys~/assets/bdc-kpi/bdc-trend-down.svg'),
      zongjibg1: require('@Sys~/assets/zongji_bg.png'),
      zongjibg: {
        backgroundImage: 'url(' + require('@Sys~/assets/zongji_bg.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      },

      radio1: '1',
      updateTime: '',
      updateTime1: '',

      dialogFormVisible: false,
      formLabelWidth: '100px',
      form: {
        monthTime: new Date().Format('yyyy-MM'),
        appkey: '',

        payKpiAndroid: '',
        payKpiIos: '',
        payKpiOther: '',
        regKpiAndroid: '',
        regKpiIos: '',
        regKpiOther: ''
        // regKpi: "",
        // payKpi: "",
      },

      dialogTableVisible: false,
      tableTitle: '',
      tableData1: [],

      incomeSum: 0,
      regroleSum: 0,
      incomeKpiSums: 0,
      regroleKpiSums: 0,
      incomeKpirate: 0,
      regroleKpirate: 0,

      row: {},

      // 表格
      listLoading: false,
      caseTable: [], // 存放后端一次性返回的所有数据

      listLoading2: false,
      caseTable2: [], // 存放后端一次性返回的所有数据

      operatorsList: [],
      distributionRegion: [],
      platforms_list: [{
        label: '安卓', value: 'android'
      }, {
        label: 'IOS', value: 'ios'
      }, {
        label: '其他', value: 'other'
      }],
      tiaojian: {
        gameName: '',
        distributionRegion: [],	// 地区
        operators: [],	// 运营商
        platforms: []
      },
      listQuery: {
        sortParameters: 'incomeYesterday',	// 排序字段
        sortWay: 'desc'	// 排序
      },
      pageNo: 1,
      pageSize: 10,

      listQuery2: {
        'sortParameters': 'incomeYesterday',
        'sortWay': 'desc'
      },
      pageNo2: 1,
      pageSize2: 10,

      isVip_2: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('developer') > -1 || this.$store.getters.roles.indexOf('vip_2') > -1,

      last_days: 0,

      info_theDimension: '',

      bdcTableHeight: 400

    }
  },

  computed: {
    tableHeightDaily() {
      return this.isBdc ? this.bdcTableHeight : 'calc(100vh - 260px)'
    },
    tableHeightMonthly() {
      return this.isBdc ? this.bdcTableHeight : 'calc(100vh - 400px)'
    }
  },

  watch: {
    radio1() {
      if (this.isBdc) {
        this.updateBdcTableHeight()
      }
    },
    listLoading(val) {
      if (this.isBdc && !val) {
        this.updateBdcTableHeight()
      }
    }
  },

  created() {
    var curDate = new Date()
    var curMonth = curDate.getMonth() // 当前月份 需要加1
    if (curMonth == 0) {
      curDate.setMonth(curMonth)
    } else {
      curDate.setMonth(curMonth + 1)
    }
    curDate.setDate(0) // 关键
    this.last_days = curDate.getDate() - new Date().getDate() + 1

    this.operatorsList_fn()
    this.distributionRegion_fn()

    this.getList()
    this.getList_m()

    console.log('测试测试测试！！！33333')
  },

  mounted() {
    if (this.isBdc) {
      this.initBdcTableLayout()
    }
  },

  beforeDestroy() {
    this.destroyBdcTableLayout()
  },

  methods: {
    initBdcTableLayout() {
      this.updateBdcTableHeight()
      if (typeof ResizeObserver !== 'undefined') {
        this._bdcTableObserver = new ResizeObserver(() => {
          clearTimeout(this._bdcTableResizeTimer)
          this._bdcTableResizeTimer = setTimeout(() => {
            this.updateBdcTableHeight()
          }, 100)
        })
        this.$nextTick(() => {
          if (this.$refs.bdcTableArea) {
            this._bdcTableObserver.observe(this.$refs.bdcTableArea)
          }
        })
      } else {
        this._bdcTableResizeHandler = () => this.updateBdcTableHeight()
        window.addEventListener('resize', this._bdcTableResizeHandler)
      }
    },

    destroyBdcTableLayout() {
      clearTimeout(this._bdcTableResizeTimer)
      if (this._bdcTableObserver) {
        this._bdcTableObserver.disconnect()
        this._bdcTableObserver = null
      }
      if (this._bdcTableResizeHandler) {
        window.removeEventListener('resize', this._bdcTableResizeHandler)
        this._bdcTableResizeHandler = null
      }
    },

    updateBdcTableHeight() {
      this.$nextTick(() => {
        const area = this.$refs.bdcTableArea
        if (area) {
          this.bdcTableHeight = Math.max(area.clientHeight, 240)
        }
      })
    },

    trendIconSrc(value) {
      return Number(value) > 0 ? this.bdcTrendUpIcon : this.bdcTrendDownIcon
    },

    trendIconStyle(value, period) {
      if (period === 'today') {
        return { float: 'left', marginTop: '20px' }
      }
      const isUp = Number(value) > 0
      return { float: 'left', marginTop: isUp ? '6px' : '4px' }
    },

    trendTextClass(value) {
      if (value === '--' || value === '0' || String(value).length > 8) return ''
      const positive = Number(value) > 0
      if (this.isBdc) {
        return positive ? 'bdc-trend-up' : 'bdc-trend-down'
      }
      return positive ? 'trend-up-legacy' : 'trend-down-legacy'
    },

    kpiProgressFormat(percentage) {
      const num = Number(percentage)
      if (!Number.isFinite(num)) return '0%'
      if (num >= 1000) return `${Math.round(num)}%`
      if (num >= 100) return `${Math.round(num * 10) / 10}%`
      return `${Math.round(num * 100) / 100}%`
    },

    kpiProgressWrapClass(percentage) {
      const text = this.kpiProgressFormat(percentage)
      if (text.length > 7) return 'is-tiny-rate'
      if (text.length > 5) return 'is-mini-rate'
      if (text.length > 4) return 'is-compact-rate'
      return ''
    },

    // 运营筛选
    operatorsList_fn() {
      homepageOperatorsList().then(response => {
        this.operatorsList = response.data
      })
    },
    // 地区筛选
    distributionRegion_fn() {
      homepageDistributionRegion().then(response => {
        this.distributionRegion = response.data
      })
    },

    bianjimubiao(index, row) {
      this.dialogFormVisible = true
      var yuefen = ''
      if (new Date().getDate() == 1) {
        // 上月1号到昨日
        yuefen = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).Format('yyyy-MM')
      } else {
        yuefen = new Date().Format('yyyy-MM')
      }
      this.info_theDimension = row.theDimension
      this.form = {
        monthTime: yuefen,
        appkey: row.appkey,

        // regKpi: row.regroleTargetYesterday,
        // payKpi: row.incomeTargetYesterday,

        payKpiAndroid: row.payKpiAndroid ? row.payKpiAndroid : 0.00,
        payKpiIos: row.payKpiIos ? row.payKpiIos : 0.00,
        payKpiOther: row.payKpiOther ? row.payKpiOther : 0.00,
        regKpiAndroid: row.regKpiAndroid ? row.regKpiAndroid : 0.00,
        regKpiIos: row.regKpiIos ? row.regKpiIos : 0.00,
        regKpiOther: row.regKpiOther ? row.regKpiOther : 0.00,

        userId: this.$store.getters.userId,
        gameid: row.gameid
      }
      this.row = row
    },
    bianjimubiao1(index, row) {
      this.dialogFormVisible = true
      var yuefen = row.monthTime.split(' ')[0]
      // if (new Date().getDate() == 1) {
      //   // 上月1号到昨日
      //   yuefen = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).Format("yyyy-MM")
      // } else {
      //   yuefen = new Date().Format("yyyy-MM")
      // }
      this.info_theDimension = row.theDimension
      this.form = {
        monthTime: yuefen,
        appkey: row.appkey,

        // regKpi: row.regroleTargetYesterday,
        // payKpi: row.incomeTargetYesterday,

        payKpiAndroid: row.payKpiAndroid ? row.payKpiAndroid : 0.00,
        payKpiIos: row.payKpiIos ? row.payKpiIos : 0.00,
        payKpiOther: row.payKpiOther ? row.payKpiOther : 0.00,

        regKpiAndroid: row.regKpiAndroid ? row.regKpiAndroid : 0.00,
        regKpiIos: row.regKpiIos ? row.regKpiIos : 0.00,
        regKpiOther: row.regKpiOther ? row.regKpiOther : 0.00,

        userId: this.$store.getters.userId,
        gameid: row.gameid
      }
      this.row = row
    },
    SaveKpi() {
      console.log(this.form)
      this.form.payKpiAndroid = this.form.payKpiAndroid == '' || this.form.payKpiAndroid < 0 ? 0 : this.form.payKpiAndroid
      this.form.payKpiIos = this.form.payKpiIos == '' || this.form.payKpiIos < 0 ? 0 : this.form.payKpiIos
      this.form.payKpiOther = this.form.payKpiOther == '' || this.form.payKpiOther < 0 ? 0 : this.form.payKpiOther

      this.form.regKpiAndroid = this.form.regKpiAndroid == '' || this.form.regKpiAndroid < 0 ? 0 : this.form.regKpiAndroid
      this.form.regKpiIos = this.form.regKpiIos == '' || this.form.regKpiIos < 0 ? 0 : this.form.regKpiIos
      this.form.regKpiOther = this.form.regKpiOther == '' || this.form.regKpiOther < 0 ? 0 : this.form.regKpiOther

      this.form.payKpi = parseFloat(this.form.payKpiAndroid) + parseFloat(this.form.payKpiIos) + parseFloat(this.form.payKpiOther)
      this.form.regKpi = parseFloat(this.form.regKpiAndroid) + parseFloat(this.form.regKpiIos) + parseFloat(this.form.regKpiOther)

      if (this.form.payKpi < 0 || this.form.payKpi == '') {
        this.form.payKpi = 0
      }
      if (this.form.regKpi < 0 || this.form.regKpi == '') {
        this.form.regKpi = 0
      }

      homepageSaveKpi({}, this.form).then(response => {
        console.log('homepageSaveKpi=====', response)
        this.$message.success(response.msg)
        this.getlishilist()
        this.getList_m()
        this.dialogFormVisible = false
      })
    },

    payKpiBlur(row) {
      if (row.payKpis == row.payKpi) {
        row.show1 = false
      } else {
      }
    },
    regKpiBlur(row) {
      if (row.regKpis == row.regKpi) {
        row.show2 = false
      } else {
      }
    },
    chakanlishi(row) {
      var list = {
        1: '角色',
        2: '账号',
        3: '设备'
      }

      this.tableTitle = row.gameName + '历史数据 （维度：' + list[row.theDimension] + '）'
      this.dialogTableVisible = true
      this.row = row
      this.getlishilist()
    },

    getlishilist() {
      console.log(this.row)
      gateUrlSasapiGet({
        'header_appkey': this.row.appkey,
        'header_view_code': '1_2_12138_1',
        'header_query_time': '2021-05-18',
        'header_query_type': 1,
        'header_time_type': '0',
        'header_platform': 'pro', // （环境类型）
      }, {
        extra: { gameid: this.row.gameid }
      }).then(response => {
        if (response.code == 1) {
          response.data.forEach(item => {
            item.show1 = false
            item.show2 = false

            item.payKpis = item.payKpi
            item.regKpis = item.regKpi
          })
          this.tableData1 = response.data
        }
      })
    },

    // 获取游戏列表
    getList() {
      this.listLoading = true
      this.listQuery.distributionRegion = this.tiaojian.distributionRegion
      this.listQuery.operators = this.tiaojian.operators
      this.listQuery.gameName = this.tiaojian.gameName
      gateUrlSasapiGet({
        'header_appkey': '18f45b4962b34d4f8bfe1505c5e35bbc',
        'header_view_code': '1_2_home_page_data',
        'header_query_time': '2021-05-18',
        'header_query_type': 1,
        'header_time_type': '0',
        'header_platform': 'pro', // （环境类型）
      }, {
        extra: this.listQuery
        // pageNo: this.pageNo,
        // pageSize: this.pageSize,
      }).then(response => {
        this.listLoading = false
        // response.data.forEach(element => {
        //   element.gamePicture = 'data:image/png;base64,' + element.gamePicture
        // })
        if (response.data.length > 0) {
          this.updateTime = '今日数据更新于：' + response.data[0].updateTime
        }
        // this.caseTable.push.apply(this.caseTable, response.data.result);
        if (response.data.length > 10) {
          this.caseTable = response.data.slice(0, 10)
          var _this = this
          setTimeout(() => {
            _this.caseTable = _this.caseTable.concat(response.data.slice(10, response.data.length))
          }, 300)
          // this.$nextTick(()=>{

          // })
        } else {
          this.caseTable = response.data
        }
      })
    },

    chaxun_btn() {
      this.caseTable = []
      this.getList()
      this.caseTable2 = []
      this.getList_m()
    },

    getList_m() {
      this.listLoading2 = true
      this.listQuery2.distributionRegion = this.tiaojian.distributionRegion
      this.listQuery2.operators = this.tiaojian.operators
      this.listQuery2.gameName = this.tiaojian.gameName
      this.listQuery2.platforms = this.tiaojian.platforms

      gateUrlSasapiGet({
        'header_appkey': '18f45b4962b34d4f8bfe1505c5e35bbc',
        'header_view_code': '1_2_home_page_data_m',
        'header_query_time': '2021-05-18',
        'header_query_type': 1,
        'header_time_type': '0',
        'header_platform': 'pro', // （环境类型）
      }, {
        extra: this.listQuery2
      }).then(response => {
        this.listLoading2 = false

        if (response.code == 1) {
          response.data.records.forEach(element => {
            // element.gamePicture = 'data:image/png;base64,' + element.gamePicture
            var a = (element.incomeTargetYesterday - parseInt(element.incomeYesterday)) < 0 ? '0' : String(element.incomeTargetYesterday - parseInt(element.incomeYesterday))
            var b = (element.regroleTargetYesterday - element.regroleYesterday) < 0 ? '0' : String(element.regroleTargetYesterday - element.regroleYesterday)

            if (b == 0 && element.regroleYesterday == 0) {
              b = 1
            }
            // 计算完成度
            var a_rate = 0
            if (element.incomeYesterday <= 0) {
              a_rate = 0
            } else if (element.incomeTargetYesterday <= 0 && element.incomeYesterday > 0) {
              a_rate = 100
            } else {
              a_rate = parseInt(parseInt(element.incomeYesterday) / element.incomeTargetYesterday * 100)
            }

            var b_rate = 0
            if (element.regroleYesterday <= 0) {
              b_rate = 0
            } else if (element.regroleTargetYesterday <= 0 && element.regroleYesterday > 0) {
              b_rate = 100
            } else {
              b_rate = parseInt(parseInt(element.regroleYesterday) / element.regroleTargetYesterday * 100)
            }

            element.circle = a_rate
            element.circle2 = b_rate

            // 计算剩余天数
            var days = 0
            if (new Date().getDate() == 1) {
              days = 0
            } else {
              days = this.last_days
            }
            // 计算剩余日均kpi
            var shouru = (parseFloat(element.incomeTargetYesterday) - parseFloat(element.incomeYesterday) > 0) ? parseFloat(element.incomeTargetYesterday) - parseFloat(element.incomeYesterday) : 0
            var xinzeng = (parseFloat(element.regroleTargetYesterday) - parseFloat(element.regroleYesterday) > 0) ? parseFloat(element.regroleTargetYesterday) - parseFloat(element.regroleYesterday) : 0
            var shourujunzhi = 0
            var xinzengjunzhi = 0
            if (shouru > 0 && days > 0) {
              shourujunzhi = parseFloat(shouru / days).toFixed(2)
            } else {
              shourujunzhi = parseFloat(shouru).toFixed(2)
            }

            if (xinzeng > 0 && days > 0) {
              xinzengjunzhi = parseInt(xinzeng / days)
            } else {
              xinzengjunzhi = parseInt(xinzeng)
            }

            element.shourujunzhi = shourujunzhi
            element.xinzengjunzhi = xinzengjunzhi
            element.last_days = days
          })

          if (response.data.records.length > 0) {
            if (new Date().getDate() == 1) {
              // 上月1号到昨日
              this.updateTime1 = '累计数据周期：' + new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).Format('yyyy-MM-dd') + ' - ' + new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format('yyyy-MM-dd')

              // 本月1号到1号
              // this.updateTime1 = "累计数据周期：" + new Date().Format("yyyy-MM-01") + " - " +  new Date().Format("yyyy-MM-01");
            } else {
              this.updateTime1 = '累计数据周期：' + new Date().Format('yyyy-MM-01') + ' - ' + new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format('yyyy-MM-dd')
            }
          }

          this.caseTable2 = response.data.records
          if (response.data.recordsSum) {
            this.incomeSum = response.data.recordsSum.incomeSum
            this.regroleSum = parseInt(response.data.recordsSum.regroleSum)

            this.incomeKpiSums = parseInt(response.data.recordsSum.incomeKpiSums)
            console.log(this.incomeKpiSums)
            this.regroleKpiSums = parseInt(response.data.recordsSum.regroleKpiSums)

            var a_rate = 0
            if (this.incomeSum <= 0) {
              a_rate = 0
            } else if (this.incomeKpiSums <= 0 && this.incomeSum > 0) {
              a_rate = 100
            } else {
              a_rate = parseInt(parseInt(this.incomeSum) / this.incomeKpiSums * 100)
            }

            var b_rate = 0
            if (this.regroleSum <= 0) {
              b_rate = 0
            } else if (this.regroleKpiSums <= 0 && this.regroleSum > 0) {
              b_rate = 100
            } else {
              b_rate = parseInt(parseInt(this.regroleSum) / this.regroleKpiSums * 100)
            }

            this.incomeKpirate = a_rate
            this.regroleKpirate = b_rate
          }
        }
      })
    },

    chartsdata(data, rate) {
      var charts = {
        // color: ['#3A89FF', '#E5E5E5'],
        'legend': {
          show: false
        },
        'series': {
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center'
            }
          },
          'silent': false,
          'data': [
            {
              value: data[0],
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#969BFB' },
                    { offset: 1, color: '#3A89FF' }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            {
              value: data[1],
              itemStyle: {
                color: '#E5E5E5'
              }
            }
          ], // ["90566", "34937"],
          'name': '',
          'radius': [
            '100%',
            '85%'
          ],
          'type': 'pie'
        },
        'grid': {
        },
        'tooltip': {
          'show': false
        },
        'title': {
          'subtext': '',
          'show': true,
          'x': 'center',
          'y': 'center',
          'text': rate, // "120%",
          'textStyle': {
            'fontFamily': 'sans-serif',
            'fontSize': 14,
            'fontStyle': 'normal',
            'fontWeight': '100'
          }
        }
      }
      return JSON.parse(JSON.stringify(charts))
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      console.log(e)
      if (e.order) {
        const order = e.order == 'descending'
        this.listQuery.sortParameters = e.prop
        if (order) {
          this.listQuery.sortWay = 'desc'
        } else {
          this.listQuery.sortWay = 'asc'
        }
        this.caseTable = []
        this.getList()
      }
    },

    // 跳转到游戏
    jinruyouxi(row) {
      this.$store.dispatch('game/setAppkey', row.appkey)
      window.sessionStorage.setItem('appkey', row.appkey)
      document.cookie = 'appkey=' + row.appkey + '; path=/' + '; domain=.yingxiong.com'
      if (process.env.VUE_APP_PROJECT_TYPE == 'bdc') {
        if (process.env.VUE_APP_TITLE === 'stage') { // 测试环境
          window.open('https://test-bdc4.yingxiong.com/info/')
        } else {
          window.open('https://bdc4.yingxiong.com/info/')
        }
      } else if (process.env.VUE_APP_PROJECT_TYPE == 'gms') {
        if (process.env.VUE_APP_TITLE === 'stage') { // 测试环境
          window.open('https://test-gms.yingxiong.com/info/')
        } else {
          window.open('https://gms.yingxiong.com/info/')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 84px);
  background: #f0f2f5;
  padding: 0px 32px 20px 32px;
  .el-card.is-always-shadow {
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 5%);
  }
  .card-box {
    ::v-deep .el-card__header {
      line-height: 30px;
      padding: 24px 24px 0px 24px;
      border: none;
    }
    ::v-deep .el-card__body {
      padding: 24px 24px 24px 24px;
    }
  }
}
.zongjiDiv {
  float: left;
  width: 100%;
  height: 120px;
  margin-bottom: 20px;

  .zongjiDiv_list {
    height: 96px;
    float: left;
    width: 17%;
    min-width: 200px;
    color: #fff;

    .zongjiDiv_list_title {
      margin-top: 22px;
      font-size: 14px;
    }

    .zongjiDiv_list_value {
      margin-top: 10px;
      font-size: 24px;
      font-weight: bold;
    }
    .zongjiDiv_list_yue {
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
.grayTableTile_02 {
  ::v-deep .caret-wrapper {
    position: absolute;
    right: 20px;
    top: -16%;
  }

  ::v-deep .el-table__row--level-1 {
    background: #f0f6ff;
  }
}

.textlin {
  line-height: 14px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;

  ::v-deep span {
    font-weight: 100;
  }
}

.tric {
  width: 40px;
  height: 18px;
  background-color: #7f8294;
  position: relative;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  border-radius: 2px;
}
.tric::after {
  content: "";
  position: absolute;
  top: 4px;
  right: -10px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left: 5px solid #7f8294;
}
.tric1 {
  width: 40px;
  height: 18px;
  background-color: #75acff;
  position: relative;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  border-radius: 2px;
}
.tric1::after {
  content: "";
  position: absolute;
  top: 4px;
  right: -10px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left: 5px solid #75acff;
}

.tric2 {
  width: 60px;
  height: 18px;
  background-color: #7f8294;
  position: relative;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  border-radius: 2px;
}
.tric2::after {
  content: "";
  position: absolute;
  top: 4px;
  right: -10px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left: 5px solid #7f8294;
}
.tric3 {
  width: 60px;
  height: 18px;
  background-color: #75acff;
  position: relative;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  border-radius: 2px;
}
.tric3::after {
  content: "";
  position: absolute;
  top: 4px;
  right: -10px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left: 5px solid #75acff;
}

.form_style {
  ::v-deep .el-form-item__label {
    font-weight: 100;
  }
}
.zhibiaoshuoming1 span {
  font-weight: bold;
}
.trend-up-legacy {
  color: #24915a;
}
.trend-down-legacy {
  color: #dc582a;
}
.baocun_btnIcon {
  border-radius: 6px;
  font-weight: bold;
  color: #409eff;
  cursor: pointer;
  padding: 6px 6px;
  background: #f0f6ff;
}
.huizongjindu {
  ::v-deep .el-progress__text {
    color: #fff;
    font-size: 16px !important;
  }
}
</style>
